import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import T from '../../i18n/i18n';
import { filemanagerActions } from '../../../redux/actions';
import { Window, Header, HeaderTitle, UploadButtonBar, UploadButton, FilemanagerButton, FileManagerConfirmMessage, FilemanagerButtonGroup, Background, UploadInput, Content } from './FileManager.styles';
import Keyboard from '../../../services/keyboardShortcuts';
import ResourceUploader from '../../Forms/ResourceUploader/ResourceUploader';

export default () => {
    
    const dispatch = useDispatch();
    const opened = useSelector(state => state.filemanagerState.opened);
    const mode = useSelector(state => state.filemanagerState.mode);
    const callback = useSelector(state => state.filemanagerState.callback);

    const resourceRef = useRef();

    const [confirmRemove, setConfirmRemove] = useState(false);
    const [filesSelected, setFilesSelected] = useState([]);

    useEffect(() => {
        if (!opened) {
            return;
        }

        let escapeKey = () => {
            dispatch(filemanagerActions.closeWindow());
            return false;
        };

        Keyboard.register({key:'ESCAPE'}, escapeKey);

        return () => {
            Keyboard.unregister({key:'ESCAPE'}, escapeKey);
        }
    }, [opened, dispatch]);


    const close = () => {
        dispatch(filemanagerActions.closeWindow());
    }

    const finish = () => {
        dispatch(filemanagerActions.closeWindow());
        resourceRef.current.finish(callback);
    }

    const keyCancel = (e) => {
        e.stopPropagation();
    }

    return <>
        <Background onKeyDown={keyCancel} className={opened ? 'opened' : ''} onClick={(e) => {close()}} />
        <Window onKeyDown={keyCancel} className={opened ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value="filemanager.title"/></HeaderTitle>
            </Header>

            <Content>
                <ResourceUploader 
                    ref={resourceRef} 
                    mode={mode}
                    onSelected={setFilesSelected}
                />
            </Content>
            
            <UploadButtonBar>
                <UploadInput accept="image/png,image/jpeg" onChange={(e) => {setConfirmRemove(false); resourceRef.current.handleFileLoading(e.target.files)}} name="file-upload" id="file-upload" />
                {confirmRemove ? <>
                    {filesSelected.length > 0 ? <>
                        <FileManagerConfirmMessage><T value="filemanager.confirmRemove" /></FileManagerConfirmMessage>
                        <FilemanagerButtonGroup>
                            <FilemanagerButton color={"#0c0"} onClick={() => {setConfirmRemove(false)}}><T value="no" /></FilemanagerButton>
                            <FilemanagerButton color={"#f44"} onClick={async () => {await resourceRef.current.removeSelectedFiles(); setConfirmRemove(false)}}><T value="yes" /></FilemanagerButton>
                        </FilemanagerButtonGroup>
                    </> : null}
                </> : <>
                    {filesSelected.length === 0 && <UploadButton htmlFor="file-upload"><T value="filemanager.upload" /></UploadButton>}
                    {filesSelected.length > 0 && <FilemanagerButton color={"#f44"} onClick={() => {setConfirmRemove(true)}}><T value="filemanager.remove" /></FilemanagerButton>}
                    <FilemanagerButtonGroup>
                        {filesSelected.length > 0 && <FilemanagerButton color={"#0c0"} onClick={(e) => {finish()}}><T value="filemanager.select" /></FilemanagerButton>}
                        <FilemanagerButton color={"#999"} onClick={(e) => {close()}}><T value="filemanager.cancel" /></FilemanagerButton>
                    </FilemanagerButtonGroup>
                </>}
            </UploadButtonBar>
        </Window>
    </>;

};